import React from 'react';
import { MessageSquare } from 'lucide-react';
import ServiceHeader from '../../components/services/ServiceHeader';
import ServiceFeatureCard from '../../components/ui/ServiceFeatureCard';
import { colors } from '../../styles/theme';
import ServiceSteps from '../../components/services/sections/ServiceSteps';

const features = [
  {
    iconName: "Users",
    title: "Créez votre communauté",
    description: "Un forum d'entraide, de partage, à votre image"
  },
  {
    iconName: "MessageSquare",
    title: "Forums Thématiques",
    description: "Selon votre projet"
  },
  {
    iconName: "Award",
    title: "Système de Points",
    description: "Récompenses et badges"
  },
  {
    iconName: "Search",
    title: "Recherche Avancée",
    description: "Trouvez rapidement les articles"
  },
  {
    iconName: "Bell",
    title: "Notifications",
    description: "Restez informé en temps réel"
  },
  {
    iconName: "Shield",
    title: "Modération",
    description: "Environnement sain et sécurisé"
  }
];

const steps = [
  {
    title: "Inscrivez-vous sur FRANCE STUDENT",
    description: "Créez votre compte étudiant en quelques clics"
  },
  {
    title: "Vérifiez votre statut étudiant",
    description: "Téléchargez votre carte étudiante ou certificat de scolarité"
  },
  {
    title: "Commandez votre Forum",
    description: "Demandez la création à votre image et profitez de votre forum !"
  }
];

const RessourcesPage = () => {
  const handleOrder = () => {
    window.location.href = 'https://my.francestudent.org/store/forum';
  };
  return (
    <div>
      <ServiceHeader
        title="Forum Étudiant"
        description="Un espace d'échange et d'entraide pour toute la communauté étudiante."
        icon={<MessageSquare className="w-8 h-8 text-white" />}
        color={colors.accent1}
        imageUrl="https://i.imgur.com/haeG8WV.jpeg"
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Caractéristiques */}
        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <ServiceFeatureCard
              key={index}
              iconName={feature.iconName}
              title={feature.title}
              description={feature.description}
              color={colors.accent1}
            />
          ))}
        </div>

        {/* Catégories du forum */}
        <section className="mt-16">
          <h2 className="text-2xl font-bold mb-8">Pour quel projet ?</h2>
          <div className="bg-white rounded-2xl shadow-lg p-8">
            <div className="grid md:grid-cols-2 gap-8">
              <div>
                <h3 className="font-semibold mb-4">Études</h3>
                <ul className="space-y-3 text-gray-600">
                  <li>• Orientation et Parcours</li>
                  <li>• Méthodologie</li>
                  <li>• Examens et Concours</li>
                  <li>• Stages et Alternance</li>
                  <li>• International</li>
                </ul>
              </div>
              <div>
                <h3 className="font-semibold mb-4">Vie Étudiante</h3>
                <ul className="space-y-3 text-gray-600">
                  <li>• Logement</li>
                  <li>• Bons Plans</li>
                  <li>• Santé et Bien-être</li>
                  <li>• Associations</li>
                  <li>• Événements</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        <div class="pt-11">
          <ServiceSteps
                title="Comment en Bénéficier"
                steps={steps}
                color={colors.accent1}
                ctaText="Commander mon forum"
                onCtaClick={handleOrder}
          />
        </div>
      </div>
    </div>
  );
};

export default RessourcesPage;